module.exports = __webpack_public_path__ + "static/img/spring_tab4_select.d9f69b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab4_select.png
// module id = 362
// module chunks = 32